// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__2n0J6","overflow":"style_overflow__fZpNc","wrap":"style_wrap__VRy4j","link":"style_link__1A-Y4","active":"style_active__OoNi6"};